import { gql } from '@grandvisionhq/graphql';

const GET_PREFERRED_STORE_CODE = gql`
  query GetPreferredStoreCode {
    me {
      id
      preferredStore {
        code
      }
    }
  }
`;

export { GET_PREFERRED_STORE_CODE };
//# sourceMappingURL=get-preferred-store-code.js.map
